const categoryConfig = () => {
    return {
        scales: {
            x: {
                type: 'category',
                ticks: {
                    callback: function (val) {
                        const label = this.getLabelForValue(val) || '';
                        if (Array.isArray(label)) {
                            return label;
                        }
                        return label.split(' ').reduce(
                            (acc, word) => {
                                if ((acc[0] + ` ${word}`).length <= 20) {
                                    acc[0] += ` ${word}`;
                                } else if ((acc[1] + ` ${word}`).length <= 20) {
                                    acc[1] += ` ${word}`;
                                } else {
                                    acc[1] += ` ${word}`;
                                    acc[1] = acc[1].substring(0, 16) + '...';
                                }

                                return acc;
                            },
                            ['', ''],
                        );
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: context => {
                        const rawValue = context[0].label;
                        return rawValue;
                    },
                },
            },
        },
    };
};

export default categoryConfig;
